import React from "react";
import "./NotFound.css";
const NotFound = () => {
  return (
    <div>
      <div className="mt-5 py-5 banner">
        <h1
          className="fw-bold text-center align-items-center justify-content-center my-5"
          style={{ height: "300px" }}
        >
          Opps !!! Got Schocked...{" "}
        </h1>
      </div>
    </div>
  );
};

export default NotFound;
